import { TableCellExpanded, TableRowExpanded } from '@ksyos/design-system';
import type { CareProductType } from '@common/enums/careProductType';
import type { Uuid } from '@common/utils/uuid';
import { DisplayShortWithTooltip } from '@frontend/components/elements/DisplayShortWithTooltip';
import { FormatCurrency } from '@frontend/components/elements/FormatCurrency';
import { NullableFormattedDate } from '@frontend/components/elements/NullableFormattedDate';
import { renderEmptyCells } from '../../renderEmptyCells';
import { dividerStyling } from './../dividerStyling';

export type ActivityRowData = {
    activityCode: string | null;
    amount: number | null;
    careProductType: CareProductType | null;
    id: Uuid;
    isCounterBooking: boolean;
    notFundedReason: string | null;
    performedDate: Date | string;
    providerOrganization: string | null;
    relationNumber: string | null;
    requesterGroup: string | null;
    runNumber: number | null;
};

type FinancingTableActivityRowProps = {
    data: ActivityRowData;
    isExpanded: boolean;
};

export function FinancingTableActivityRow({ data, isExpanded }: FinancingTableActivityRowProps) {
    const {
        amount,
        activityCode,
        careProductType,
        isCounterBooking,
        performedDate,
        providerOrganization,
        notFundedReason,
        relationNumber,
        requesterGroup,
        runNumber,
    } = data;

    return (
        <TableRowExpanded isExpanded={isExpanded}>
            {renderEmptyCells(5)}
            <TableCellExpanded sx={dividerStyling}>
                <NullableFormattedDate value={performedDate} />
            </TableCellExpanded>
            <TableCellExpanded>{careProductType}</TableCellExpanded>
            <TableCellExpanded>{activityCode}</TableCellExpanded>
            <TableCellExpanded>{showDisplayShortWithTooltip(providerOrganization, 8)}</TableCellExpanded>
            <TableCellExpanded sx={{ textWrap: 'nowrap' }}>
                {showDisplayShortWithTooltip(requesterGroup, 8)}
            </TableCellExpanded>
            <TableCellExpanded>{relationNumber}</TableCellExpanded>
            <TableCellExpanded>{<FormatCurrency value={amount ?? undefined} />}</TableCellExpanded>
            <TableCellExpanded>{isCounterBooking ? 'TB' : ''}</TableCellExpanded>
            <TableCellExpanded>{runNumber}</TableCellExpanded>
            <TableCellExpanded> {showDisplayShortWithTooltip(notFundedReason, 15)}</TableCellExpanded>
            {renderEmptyCells(2)}
        </TableRowExpanded>
    );

    function showDisplayShortWithTooltip(text: string | null, length: number) {
        if (!text) {
            return null;
        }

        return (
            <DisplayShortWithTooltip
                maxLength={length}
                text={text}
            />
        );
    }
}
